import { useState } from 'react';
import ButtonLoader from '../ButtonLoader';

const BankDetails = ({ labourer, isLoading, onSubmit }) => {
  const [bankName, setBankName] = useState(labourer?.bankDetails?.bankName || '');
  const [bsbNumber, setBsbNumber] = useState(labourer?.bankDetails?.BSB || '');
  const [accountNumber, setAccountNumber] = useState(labourer?.bankDetails?.accountNumber || '');
  const [accountName, setAccountName] = useState(labourer?.bankDetails?.accountName || '');

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      bankName,
      BSB: bsbNumber,
      accountNumber,
      accountName
    });
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className='flex flex-col gap-4'
      >
        <label className='flex flex-col gap-1'>
          <span>Bank name</span>

          <input
            type="text"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>BSB Number</span>

          <input
            type="text"
            value={bsbNumber}
            onChange={(e) => setBsbNumber(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Account number</span>

          <input
            type="text"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Account name</span>

          <input
            type="text"
            value={accountName}
            onChange={(e) => setAccountName(e.target.value)}
            required
          />
        </label>

        <div className='flex'>
          <button
            type='submit'
            className='bg-ase-blue h-[48px] px-4 font-semibold text-white rounded-md'
          >
            {isLoading ? <ButtonLoader /> : 'Update'}
          </button>
        </div>
      </form>
    </>
  )
}

export default BankDetails;
